// deps - Cart, Toast

class BetterAJAX {
  constructor(images, productIds, quantities, callback) {
    this.callback = callback
    let sendDataItems = []
    productIds.forEach((productId, i) => {
      sendDataItems.push({
        quantity: typeof quantities[i] !== "undefined" ? quantities[i] : 1,
        id: productId,
      })
    })
    this.toast = new PwnageToast(images)
    this.sendToCart({ items: sendDataItems })
  }

  sendToCart(sendData) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          if (data.status > 299) {
            throw data
          }
        }
        this.toast.setState("toast--done")
        window.setTimeout(() => this.toast.setState("toast--fly"), 1500)
        PwnageCart.updateCart()
        if (this.callback) this.callback()
      })
      .catch((error) => {
        this.toast.setState("toast--error", error)
        window.setTimeout(() => this.toast.setState("toast--fly"), 2500)
      })
  }
}
